import { AvailableLanguages, languages } from '@repo/toolkit/language-types'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { en } from './src/locale/en'
import { fr } from './src/locale/fr'

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  supportedLngs: languages,
  fallbackLng: 'fr',
  resources: {
    en: { translation: en },
    fr: { translation: fr }
  },
  interpolation: {
    escapeValue: false
  }
})

const setLanguage = () => {
  const language = (localStorage.getItem('language') ?? 'fr') as AvailableLanguages
  i18n.changeLanguage(language)
}

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng)
})

setLanguage()

export default i18n
